import 'twin.macro'
import React, { useState } from 'react'
import { Combobox } from '@headlessui/react'

import { getStandardizedName } from 'common/utils/stringUtils'

import { inputBase } from 'common/components/Input/Input'
import { ExerciseSuggestions } from '../exercise/ExerciseSuggestions'

export default function ExerciseInput({ inputRef, exercises, exerciseId, setExerciseId, exVidOrientation }) {
  const [searchText, setSearchText] = useState('')
  const suggestedExercises = Object.entries(exercises).filter(([_, exercise]) =>
    getStandardizedName(exercise.name)?.includes(getStandardizedName(searchText))
  )

  return (
    <div className='mb-4'>
      <label className='capitalize inline-flex cursor-pointer font-semibold text-tBlack' tw='mb-1'>
        Exercise
      </label>
      <Combobox value={exerciseId} onChange={(value) => setExerciseId(value)} nullable>
        <div className='w-full'>
          <Combobox.Input
            ref={inputRef}
            autoFocus={true}
            placeholder='Search Exercises'
            autoComplete='off'
            onChange={(e) => setSearchText(e.target.value)}
            className='text-ellipsis bg-inherit'
            css={inputBase}
          />
        </div>
        {searchText?.length > 0 && suggestedExercises?.length > 0 && (
          <ExerciseSuggestions
            suggestedExercises={suggestedExercises}
            exVidOrientation={exVidOrientation}
            containerClasses='w-[var(--input-width)] z-[999]'
          />
        )}
      </Combobox>
    </div>
  )
}
